function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/react-overlays/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 1324
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16